import { render, staticRenderFns } from "./AchievementModal.vue?vue&type=template&id=ed6ad3d8&scoped=true"
import script from "./AchievementModal.vue?vue&type=script&lang=ts"
export * from "./AchievementModal.vue?vue&type=script&lang=ts"
import style0 from "./AchievementModal.vue?vue&type=style&index=0&id=ed6ad3d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6ad3d8",
  null
  
)

export default component.exports